module.exports = __webpack_public_path__ + "img/Carte-classique.d5e78dc4.png";